export const SYNC_POLL_INTERVAL = 3 * 1000; // 3 seconds
